export default "__VITE_ASSET__BvWs8aWw__"